import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { uploadImagem } from '../../firebase/uploadImagem';
import { getImageUrl } from '../../firebase/storageService';
import { authFetch } from '../../utils/authFetch';
import DateInput from '../../components/DateInput';

export default function EditarPaciente() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const fromBeta = location.state?.fromBeta === true;
    const { showNotification } = useNotification();
    const fileInputRef = useRef(null);

    const [formData, setFormData] = useState({
        name: '',
        statusId: '',
        shift: '',
        modalityId: '',
        fatherName: '',
        motherName: '',
        educationLevel: '',
        birthdate: '',
        anamnesisDate: '',
        interventionStartDate: '',
        contractEndDate: '',
        assessmentDate: '',
        nextAssessmentDate: '',
        therapistId: ''
    });

    const [fotoPreview, setFotoPreview] = useState(''); // Para exibir a prévia da imagem

    const [terapeutas, setTerapeutas] = useState([]);

    const situacoes = [
        { id: 0, nome: "Ativo" },
        { id: 1, nome: "Em Avaliação" },
        { id: 2, nome: "Cadastrado" },
        { id: 3, nome: "Ex Paciente" },
        { id: 4, nome: "Pausado" },
    ];

    const turnos = [
        { id: 0, nome: "Manhã" },
        { id: 1, nome: "Tarde" }
    ];

    const [modalidades, setModalidades] = useState([]);;

    const buscarModalidades = async () => {
        try {
            const res = await authFetch(`modality`, {
            });

            if (!res.ok) throw new Error();
            const data = await res.json();

            setModalidades(data);
            
        } catch (err) {
            showNotification('danger', 'Erro ao carregar modalidades');
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await authFetch(`patient/${id}`, {                    
                });

                if (!res.ok) throw new Error();
                const data = await res.json();

                setFormData(data);
                buscarModalidades();

                // Carrega a imagem do Firebase
                const url = await getImageUrl('patient', id);
                setFotoPreview(url); // ← aqui!
            } catch (err) {
                showNotification('danger', 'Erro ao carregar dados do paciente');
            }
        };

        fetchData();
    }, [id]);


    useEffect(() => {
        const fetchTerapeutas = async () => {
            try {
                const response = await authFetch(`therapist`, {                    
                });
                const data = await response.json();
                setTerapeutas(data);
            }
            catch (err) {
                console.error(err);
                showNotification("danger", "Erro ao buscar terapeutas");
            }
        }
        fetchTerapeutas();
    }, [showNotification]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image' && files?.length > 0) {
            const file = files[0];

            // Atualiza o estado com o arquivo
            setFormData((prev) => ({
                ...prev,
                image: file,
            }));

            // Atualiza o preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setFotoPreview(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            // Para os outros campos
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const imageFile = formData.image;
        let imageUrl = null;


        try {
            // Garantir que therapistId = 0 seja enviado como null
            const therapistIdValue = formData.therapistId && Number(formData.therapistId) !== 0 
                ? Number(formData.therapistId) 
                : null;

            const payload = {
                id: Number(id),
                name: formData.name,
                birthdate: formData.birthdate,
                note: formData.note,
                anamnesisDate: formData.anamnesisDate,
                statusId: Number(formData.statusId),
                contractEndDate: formData.contractEndDate,
                fatherName: formData.fatherName,
                motherName: formData.motherName,
                educationLevel: formData.educationLevel,
                therapistId: therapistIdValue,
                assessmentDate: formData.assessmentDate,
                interventionStartDate: formData.interventionStartDate,
                // urlFile: null,
                shift: Number(formData.shift),
                nextAssessmentDate: formData.nextAssessmentDate,
                modalityId: Number(formData.modalityId)
            }

            // Upload da imagem no Firebase, se houver
            if (imageFile) {
                imageUrl = await uploadImagem(imageFile, 'patient', id);
            }

            const response = await authFetch('patient', {
                method: 'PUT',                
                body: JSON.stringify(payload), // Envia como FormData
            });

            if (!response.ok) throw new Error();

            showNotification('success', 'Paciente atualizado com sucesso');
            navigate(fromBeta ? '/PacientesBeta' : `/Pacientes/PerfilPaciente/${id}`, fromBeta ? { state: { returnScrollToId: id } } : undefined);
        } catch {
            showNotification('danger', 'Erro ao salvar paciente');
        }
    };

    return (
        <div className="content">
            <div className="card">
                <div className="card-body p-3">
                    <form onSubmit={handleSubmit}>
                        <div className="row col-md-12">
                            <div className="col-md-2">
                                <div className="personal-image">
                                    <input
                                        type="file"
                                        name="image"
                                        id="arquivo"
                                        accept="image/*"
                                        onChange={handleChange}
                                        ref={fileInputRef}
                                        style={{ display: 'none' }}
                                    />
                                    <figure className="personal-figure">
                                        <img
                                            src={fotoPreview || require('../../assets/img/perfilvazio.png')} // Exibe a prévia ou imagem padrão
                                            className="personal-avatar"
                                            alt="imagem-perfil"
                                            onClick={() => fileInputRef.current.click()}
                                            style={{ cursor: 'pointer', width: '100%' }}
                                        />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-md-10">
                                <h2>{formData.name}</h2>
                                <Link to={fromBeta ? '/PacientesBeta' : `/Pacientes/PerfilPaciente/${id}`} state={fromBeta ? { returnScrollToId: id } : undefined} className="btn btn-info btn-sm">Cancelar</Link>
                            </div>
                        </div>

                        <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#nav-dados" type="button">Dados</button>
                            </div>
                        </nav>

                        <div className="tab-content mt-3">
                            <div className="tab-pane fade show active" id="nav-dados">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Nome Paciente</label>
                                        <input type='text' className='form-control form-control-sm' name="name" value={formData.name} onChange={handleChange} />
                                        <input type='hidden' className='form-control form-control-sm' name="id" value={formData.id} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Situação</label>
                                        <select name="statusId" className='form-control form-control-sm' value={formData.statusId} onChange={handleChange}>
                                            {situacoes.map(s => (
                                                <option key={s.id} value={s.id}>
                                                    {s.nome}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label>Turno</label>
                                        <select className='form-control form-control-sm' name="shift" value={formData.shift} onChange={handleChange}>
                                            {turnos.map(s => (
                                                <option key={s.id} value={s.id}>
                                                    {s.nome}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Modalidade</label>
                                        <select className='form-control form-control-sm' name="modalityId" value={formData.modalityId} onChange={handleChange} >
                                            {modalidades.map(s => (
                                                <option key={s.id} value={s.id}>
                                                    {s.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label>Nome do Pai</label>
                                        <input type='text' className='form-control form-control-sm' name="fatherName" value={formData.fatherName} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Nome do Mãe</label>
                                        <input type='text' className='form-control form-control-sm' name="motherName" value={formData.motherName} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Escolaridade</label>
                                        <textarea
                                            className="form-control form-control-sm"
                                            name="educationLevel"
                                            value={formData.educationLevel}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label>Data de Nascimento</label>
                                        <DateInput
                                            className='form-control form-control-sm'
                                            name="birthdate"
                                            value={formData.birthdate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Data da Anamnese</label>
                                        <DateInput
                                            className='form-control form-control-sm'
                                            name="anamnesisDate"
                                            value={formData.anamnesisDate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Data Início Intervenção</label>
                                        <DateInput
                                            className='form-control form-control-sm'
                                            name="interventionStartDate"
                                            value={formData.interventionStartDate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Data Fim do Contrato</label>
                                        <DateInput
                                            className='form-control form-control-sm'
                                            name="contractEndDate"
                                            value={formData.contractEndDate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Data Última Avaliação</label>
                                        <DateInput
                                            className='form-control form-control-sm'
                                            name="assessmentDate"
                                            value={formData.assessmentDate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Data Próxima Avaliação</label>
                                        <DateInput
                                            className='form-control form-control-sm'
                                            name="nextAssessmentDate"
                                            value={formData.nextAssessmentDate}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Gestora de Caso</label>
                                        <select className='form-control form-control-sm' name="therapistId" value={formData.therapistId} onChange={handleChange} >
                                            <option>Selecione</option>
                                            {terapeutas.map(s => (
                                                <option key={s.id} value={s.id}>
                                                    {s.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="card-footer" style={{ paddingLeft: 0 }}>
                                    <button type="submit" className="btn btn-primary btn-sm">Salvar</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
